import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {
  BadgeComponent,
  ButtonDirective,
  CardBodyComponent,
  CardComponent,
  CardHeaderComponent,
  ColComponent,
  ContainerComponent,
  IColumn,
  OffcanvasBodyComponent,
  OffcanvasComponent,
  OffcanvasHeaderComponent,
  OffcanvasModule,
  ProgressComponent,
  RowComponent,
  SmartTableComponent,
  SmartPaginationComponent,
  TableActiveDirective,
  TableColorDirective,
  TemplateIdDirective,
  TooltipDirective,
  WidgetStatCComponent
} from '@coreui/angular-pro';

import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ChartjsComponent } from '@coreui/angular-chartjs';
import { DataTablesModule } from 'angular-datatables';
import { IQueryFilterRange, IUtilisationDepot, IUtilisationSnapshotResponse, IVehicleUtilisationSnapshot, RangeFilterOption } from '../../../models/vehicle-status.model';
import { VehicleStatusService } from '../../../services/vehicle-status.service';
import { FilterPanelComponent } from '../../daily-vehicle-count/components/filter-panel/filter-panel.component';
import usersData from './data';
import { ChartData } from 'chart.js';
import { StatusFlyoutComponent } from './status-flyout/status-flyout.component';
import { Subscription, interval, BehaviorSubject } from 'rxjs';
import { cilBadge, cilArrowCircleRight, cilMediaStop, cilMediaPlay } from '@coreui/icons';
import { IconDirective } from '@coreui/icons-angular';
import { RangeFilterComponent } from '../../../components/range-filter/range-filter.component';
import { CurrentUtilisationScoreWidgetComponent } from '../../../components/current-utilisation-score-widget/current-utilisation-score-widget.component';
import { DateRangeLabelComponent } from '../../../components/date-range-label/date-range-label.component';
import { AuthInterceptor } from '../../../interceptors/http-interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NavItemsService } from '../../services/nav-service';
import moment from 'moment';


@Component({
  selector: 'app-depot-live-summary',
  standalone: true,
  imports: [
    ChartjsComponent,
    FilterPanelComponent,
    ContainerComponent,
    RowComponent,
    ColComponent,
    BadgeComponent,
    ButtonDirective,
    CardComponent,
    CardBodyComponent,
    CommonModule,
    CardHeaderComponent,
    DataTablesModule,
    OffcanvasComponent,
    OffcanvasHeaderComponent,
    OffcanvasModule,
    OffcanvasBodyComponent,
    SmartTableComponent,
    SmartPaginationComponent,
    TemplateIdDirective,
    TableActiveDirective,
    TableColorDirective, NgTemplateOutlet, TooltipDirective, IconDirective,
    RowComponent,
    StatusFlyoutComponent,
    RangeFilterComponent,
    CurrentUtilisationScoreWidgetComponent,
    WidgetStatCComponent,
    ProgressComponent,
    DateRangeLabelComponent
  ],
  templateUrl: './depot-live-summary.component.html',
  styleUrl: './depot-live-summary.component.scss',
  providers:[    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ]
})

export class DepotLiveSummaryComponent implements OnInit, OnDestroy {

  // snapshotData$!: Subject<IUtilisationSnapshotResponse>;
  private snapshotData$!: Subscription;
  paramSubscription!: Subscription;

  icons = { cilBadge, cilArrowCircleRight, cilMediaStop, cilMediaPlay };

  isFlyoutVisible: boolean = false;
  selectedSnapshot!: IVehicleUtilisationSnapshot;



  weeklyChartData: ChartData = {
    labels: [],
    datasets: []
  };

  weeklyChartOptions = {
    scales: {
      y: {
        beginAtZero: true,
        stacked: true,
        max: 100,
        title: {
          display: true,
          text: "Percentage"
        }
      },
      x: {
        stacked: true
      }
    },
    plugins: {
      legend: {
        display: true,
        position: 'top' as const
      },
      tooltip: {
        enabled: true
      }
    }
  };

  vehicleStatusOptions = {};
  vehicleUtilizationData: ChartData = {
    labels: [],
    datasets: []
  };

  // current week.
  // Monday start of week.
  vehicleStatusData: ChartData = {
    labels: [],
    datasets: [

    ]
  };


  vehicleUtilizationOptions = {};
  vehicleUtilisationListPage = 1;
  vehicleUtilisationListTotalPages = 1;
  vehicleUtilisationListPageSize = 20;
  vehicleUtilisationListLoading = true;
  vehicleUtilisationListFilters = {}
  vehicleUtilisationList: IVehicleUtilisationSnapshot[] = [];
  depotId: string | null = null;

  usersData = usersData;

  columns: (IColumn | string)[] = [
    {
          label: 'Vehicle',
          key: 'vehicle_registration_field',
          _labelTemplateId: 'all',
          _style: { width: '12%' },
      _props: { class: 'fw-bold' },
    },
    { label: 'Date', key: 'snapshot_date', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '10%' }, _classes: 'text-muted small' },
    { label: 'Status', key: 'is_utilized', _labelTemplateId: 'all', filter: false, sorter: true, _style: { width: '10%' }, _classes: 'text-muted small' },
    { label: 'Last Change Reason', key: 'last_utilization_change_reason', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '15%' }, _classes: 'text-muted small' },
    { label: 'Last Change Reason Date', key: 'last_utilization_change_datetime', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '15%' }, _classes: 'text-muted small' },
    { label: 'Last Known Geofence', key: 'last_entered_geofence_name', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '15%' }, _classes: 'text-muted small' },
    { label: 'Last Known Geofence Entry Time', key: 'last_entered_geofence_entry_time', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '10%' }, _classes: 'text-muted small'},
    { label: 'Last Known Geofence Exit Time', key: 'last_entered_geofence_exit_time', _labelTemplateId: 'all', filter: false, sorter: false, _style: { width: '10%' }, _classes: 'text-muted small'},
    {
      key: 'details',
      label: '',
      _style: { width: '5%' },
      filter: false,
      sorter: false
    }
  ];

  getBadge(utilisationStatus: boolean, vor: boolean) {
    return this.vehicleStatusService.getUtilisationBadgeColour(utilisationStatus, vor);
  }

  getUtilisationStatus(snapshot: IVehicleUtilisationSnapshot) {
    return this.vehicleStatusService.getUtilisationStatus(snapshot);
  }

  todaySnapshot!: IUtilisationDepot;
  todaySnapshotSubTitletext = '';
  apiParams!: { snapshot_date_start: string, snapshot_date_end: string, depot_id: string }
  dataUpdateDateStamp = Date.now();
  autoRefreshEnabled = true;
  autoRefreshIcon = this.icons.cilMediaStop;

  rangeSelectorValue: IQueryFilterRange = IQueryFilterRange.Today
  dateRangeOptions: RangeFilterOption[] = [
    { value: IQueryFilterRange.Today, label: "Today" },
    { value: IQueryFilterRange.Yesterday, label: "Yesterday" }
  ];
  screenTitle = '';

  constructor(
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private vehicleStatusService: VehicleStatusService,
    private router: Router,
    private navDataService : NavItemsService
  ) {
    this.paramSubscription = route.params.subscribe(() => this.onParamChange());

  }

  ngOnInit(): void {
    this.startSnapshotDataSubject();

  }
  ngOnDestroy() {
    this.paramSubscription.unsubscribe();
   this.stopSnapshotDataSubject();
  }

  startSnapshotDataSubject() {
    // this.snapshotData$ = timer(3000, 10000).pipe(
    //   switchMap(()=>  this.vehicleStatusService.getVehicleUtilisationSnapshots(this.apiParams))
    // ).subscribe((data) => {
    //   console.log('timer: ', this.dataUpdateDateStamp);
    //   this.autoRefreshEnabled = true;
    //   this.autoRefreshIcon = this.icons.cilMediaStop;
    //   this.updateTableSnapshotData(data);
    //   this.dataUpdateDateStamp = Date.now();
    // })
    this.autoRefreshEnabled = true;
    this.autoRefreshIcon = this.icons.cilMediaStop;
    this.snapshotData$ = interval(30000).subscribe(() => {
      console.log('Interval')
      this.onParamChange();
  });
  }
  stopSnapshotDataSubject() {
    this.autoRefreshEnabled = false;
    this.autoRefreshIcon = this.icons.cilMediaPlay;
    this.snapshotData$.unsubscribe();
  }

  toggleAutoRefresh() {
    if (this.autoRefreshEnabled) {
      this.stopSnapshotDataSubject();
    } else {
      this.startSnapshotDataSubject();
    }
  }

  handleRouteFilterChange($event: any) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        range: $event.currentTarget?.value
      },
      queryParamsHandling: "merge"
    }).then(res => {
      // this.onRouteChange(this.route.snapshot.params)
      this.rangeSelectorValue = $event.currentTarget?.value;
      this.onParamChange()
    })
  }

  // async onRouteChange(params: Params): Promise<void> {

  // }

  onParamChange() {
    this.vehicleUtilisationListLoading = true;
    // Get the  Depot ID from the route params
    console.log(history)
    const departmentId = this.route.snapshot.paramMap.get('departmentId');
    const regionId = this.route.snapshot.paramMap.get('regionId');
    this.depotId = this.route.snapshot.paramMap.get('depotId');

    const todaysDate = new Date();

    const momentStartOfWeek = moment(todaysDate).startOf('week').add(1, 'day'); //;
    const momentEndOfWeek = moment().endOf('week');
    const yearAndMonth = `${todaysDate.getFullYear()}-${todaysDate.getMonth() + 1}`;
    const _paramsThisWeek = {
      snapshot_date_start: `${momentStartOfWeek.format('YYYY-MM-DD')}`,
      snapshot_date_end: `${momentEndOfWeek.format('YYYY-MM-DD')}`,
      depot_id: this.depotId as string
    }
    let _tableStartDate;
    let _tableEndDate;
    switch (this.rangeSelectorValue) {
      case IQueryFilterRange.Today:
        _tableStartDate = `${yearAndMonth}-${todaysDate.getDate()}`;
        _tableEndDate = _tableStartDate;
        break;
      case IQueryFilterRange.Yesterday:
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1)
        const yesterdayYear = yesterday.getFullYear();
        const yesterdayMonth = String(yesterday.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const yesterdayDay = String(yesterday.getDate()).padStart(2, '0');
        _tableStartDate = `${yesterdayYear}-${yesterdayMonth}-${yesterdayDay}`;
        _tableEndDate = _tableStartDate;
        break;

      default:
        // Today
        _tableStartDate = `${yearAndMonth}-${todaysDate.getDate()}`;
        _tableEndDate = _tableStartDate;
        break;
    }


    const _params = {
      snapshot_date_start: _tableStartDate, //`2024-11-26`,
      snapshot_date_end: _tableEndDate, //`2024-11-27`,
      depot_id: this.depotId as string,
      pageSize: this.vehicleUtilisationListPageSize.toString(),
      page: this.vehicleUtilisationListPage.toString(),
      ...this.vehicleUtilisationListFilters,
    }
    this.apiParams = _params;

    this.navDataService.navDataReceivedObservable.subscribe(() => {
      this.screenTitle = `${this.navDataService.findDepotName(
        parseInt(departmentId as string),
        parseInt(regionId as string),
        parseInt(this.depotId as string)
      )} `;
    });

    this.vehicleStatusService.getVehicleUtilisationSnapshots(_params).subscribe((data) => {
      this.updateTableSnapshotData(data);
    });

    // Setup first graph
    this.vehicleStatusService.getVehicleUtilizationStatistics(_paramsThisWeek).subscribe((data) => {

      const {weeklyChartData, vehicleUtilizationData} = this.vehicleStatusService.refactorVehicleStatsDataForGraphs(data)
      if (Object.keys(data).length > 0) {
        this.todaySnapshot = data[Object.keys(data)[Object.keys(data).length - 1]];
        this.todaySnapshotSubTitletext = `Vehicle count: ${this.todaySnapshot.total_count}, Used: ${this.todaySnapshot.utilized_count}, Unused: ${this.todaySnapshot.unutilized_count}`  
      }
           //this.todaySnapshot = data.results[0];
      this.weeklyChartData = weeklyChartData;
      this.vehicleUtilizationData = vehicleUtilizationData;

      this.cdr.detectChanges()
    })

    // Setup second graph

    this.vehicleStatusService.getVehicleUtilizationReasonStatistics(_paramsThisWeek).subscribe(data=>
      {
        this.vehicleStatusData =
        {
          labels: ["Missing Driver Check", "Standard Vehicle Check Complete Report", "Defect", "Lack of Driver Check"],
          datasets: [
            {
              data: [] as number[], // Sample data values for each status
              backgroundColor: ["#D1D4D8", "#BFABA6" ,"#EAFCF6", "#98F1D0"], // Corresponding colors for VOR, In Use, Available
              hoverOffset: 4
           }
          ]
        }
        this.vehicleStatusData.datasets[0].data[0] = data['Missing Driver Check'];
        this.vehicleStatusData.datasets[0].data[1] = data['Standard Vehicle Check Complete Report'];
        this.vehicleStatusData.datasets[0].data[2] = data['DEFECT'];
        this.vehicleStatusData.datasets[0].data[3] = data['Lack of Driver Check'];

        this.cdr.detectChanges()
      })

  }

  updateTableSnapshotData(data: IUtilisationSnapshotResponse) {
    this.vehicleUtilisationListLoading = false;
    this.vehicleUtilisationListTotalPages = Math.ceil(data.count / this.vehicleUtilisationListPageSize);

    // if (data.results.length > 0 ) {
      this.vehicleUtilisationList = data.results.map(item => {
        let i = item;

        (i as any).vehicle_registration_field = i?.vehicle?.registration

        delete (i as any).comment;
        // delete (i as any).manually_marked_as_utilized;
        delete (i as any).depot;
        delete (i as any).vehicle;

        return i;
      });
      this.dataUpdateDateStamp = Date.now();
    // }


    this.cdr.detectChanges();
  }

  handleRowClick($event: any) {
    this.selectedSnapshot = $event.item;
    this.isFlyoutVisible = true;
  }

  handleChartRef($chartRef: any) {
    if ($chartRef) {
      setTimeout(() => {
        $chartRef?.update();
      }, 3000);
    }
  }

  flyoutEventChanged($event: boolean) {
    if ($event) {
      this.onParamChange();
    }
  }

  loadVehicleUtilisationListPage (page: number) {
    this.vehicleUtilisationListPage = page;
    this.onParamChange();
  }

  vehicleUtilisationFilterValueChange (e: any) {
    this.vehicleUtilisationListFilters = {
      vehicle__registration: e.vehicle_registration_field,
    };
    this.onParamChange();
  }
}
